import React, { Component, useEffect } from 'react';
import {
    LOGO, HEROImg, ICONDataset, BGCount, ICONCategory, ICONOrganization, ILEmptyData, ILEmptyKategori, ILEmptyOrganisasi
} from "src/assets"
import "./style.css";
import { HeaderGlobal } from 'src/components/molecules';
import { Helmet } from 'react-helmet';
import { setDataHomes, setDataNews, setFormSearchDatas } from 'src/config/redux/action'
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import CountUp from 'react-countup';
import { useHistory } from 'react-router';
import { Link } from "react-router-dom";

const Home = () => {
    const { dataHomes, dataNews } = useSelector(state => state.homeReducer)
    const { formSearchDatas } = useSelector(state => state.dataReducer);
    const {
        SearchText
    } = formSearchDatas;
    const history = useHistory();
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setDataHomes())
        dispatch(setDataNews())
        dispatch(setFormSearchDatas('SearchText', ''))
    }, [dispatch])

    const handleKeyDownSearch = (event) => {
        if (event.key === 'Enter') {
            history.push(`/data`)
        }
    }

    var slick_kategori = {
        dots: false,
        arrow: false,
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1199,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3
            }
        },
        {
      
            breakpoint: 1024,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3
            }
        },
        {
      
            breakpoint: 680,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    };
    const slick_berita = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
        dataHomes ?
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>{`Portal Satu Data | Kabupaten Sigi`}</title>
                <meta name='description' content={`Integrasi satu data mewujudkan Kabupaten Sigi Yang Maju, Mandiri Berbasis Ekonomi Kerakyatan - Portal Satu Data Kabupaten Sigi`} />
            </Helmet>
            <HeaderGlobal />
            
            <section className="hero">
                <div className="container">
                    <div className="row py-5">
                        <div className="col-md-6 align-self-center" data-aos="fade-down">
                            <h1 className="title-head1">
                                PORTAL
                            </h1>
                            <h1 className="title-head2">
                                SATU DATA KABUPATEN SIGI
                            </h1>
                            <p className="title-desc">
                                Integrasi satu data mewujudkan Kabupaten Sigi Yang Maju, Mandiri Berbasis Ekonomi Kerakyatan
                            </p>
                            <div className="mt-4 align-self-center" data-aos="zoom-in">
                                <input
                                    onChange={(e) => dispatch(setFormSearchDatas('SearchText', e.target.value))} 
                                    value={SearchText}
                                    onKeyDown={handleKeyDownSearch} 
                                    type="text" 
                                    className="textinput-search py-2 px-4"
                                    placeholder="Cari Dataset..." />
                                <Link to={'/data'} className="btn btn-primary ml-4 px-4 py-2">
                                    CARI
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-6" data-aos="fade-up-left">
                            <img src={HEROImg} className="img-fluid" alt="" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="count" style={{backgroundImage:`url(${BGCount})`}}>
                <div className="countx">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 d-flex justify-content-center text-center" data-aos="fade-up">
                                <div className="card-count">
                                    <center>
                                        <div className="icon-count p-2 mb-2 d-flex align-items-center justify-content-center">
                                            <img src={ICONDataset} className="img-fluid" width={30} height={30} alt="" />
                                        </div>
                                    </center>
                                    <span>Dataset</span>
                                    <div>
                                        <CountUp className='text-count' start={0} end={dataHomes.DataCount.Dataset} duration={30} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 d-flex justify-content-center text-center" data-aos="fade-up">
                                <div className="card-count">
                                    <center>
                                        <div className="icon-count p-2 mb-2 d-flex align-items-center justify-content-center">
                                            <img src={ICONOrganization} className="img-fluid" width={50} height={50} alt="" />
                                        </div>
                                    </center>
                                    <span>Organisasi</span>
                                    <div>
                                        <CountUp className='text-count' start={0} end={dataHomes.DataCount.Agency} duration={30} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 d-flex justify-content-center text-center" data-aos="fade-up">
                                <div className="card-count">
                                    <center>
                                        <div className="icon-count p-2 mb-2 d-flex align-items-center justify-content-center">
                                            <img src={ICONCategory} className="img-fluid" width={35} height={35} alt="" />
                                        </div>
                                    </center>
                                    <span>Kategori</span>
                                    <div>
                                        <CountUp className='text-count' start={0} end={dataHomes.DataCount.Category} duration={30} />
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>

            

            <section className="category">
                <div className="container">
                    <center data-aos="zoom-in">
                        <h3>
                            Telusuri Berdasarkan Kategori
                        </h3>
                        <div className="garis"></div>
                    </center>
                        <div className="mt-5">
                            {
                                dataHomes.Categories.length !== 0 ?
                                    <Slider {...slick_kategori} slidesToShow={4}>
                                        {
                                            dataHomes.Categories.map((v, i) => {
                                            const duration = 250 * i;
                                                return (
                                                    <div key={i} data-aos='fade-up' data-aos-delay={duration}>
                                                        <div className="card-category p-3">
                                                            <center>
                                                                <img src={v.FileLogo} className="img-fluid" width="300" alt="" />
                                                            </center>
                                                            <div className='title text-center'>
                                                                <h5 className="mt-3">
                                                                    {v.Name}
                                                                </h5>
                                                            </div>
                                                            <p style={{ WebkitLineClamp: 3, textOverflow: 'ellipsis', display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{v.Description}.</p>
                                                            <Link to={`/kategori/detail/${v.Slug}`} className="btn btn-primary btn-block">
                                                                DATASET ({v.DatasetCount})
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </Slider>
                                    :
                                    <div className="col-md-12 text-center" data-aos="fade-up">
                                        <img src={ILEmptyKategori} className={'img-fluid'} width={300} /> <br />
                                        <div className='mt-4'>
                                            <p>Kategori tidak ditemukan!</p>
                                        </div>
                                    </div>

                            }
                    </div>
                </div>
            </section>

            <section className="news">
                <div className="container">
                    <center data-aos="zoom-in">
                        <h3>
                            Informasi Berita
                        </h3>
                        <div className="garis"></div>
                        </center>
                        {
                            dataNews &&
                                dataNews.length !== 0 ?
                                    <Slider {...slick_berita}>
                                        {
                                            dataNews.map((v, i) => {
                                                return (
                                                    <div key={i}>
                                                        <div className="card-news p-4 mt-5" data-aos="fade-down">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <img src={v.FileName} className="img-fluid"  alt="" />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <span>{v.Header}</span>
                                                                    <h4>
                                                                        {v.Title}
                                                                    </h4>
                                                                    <p>
                                                                        {v.Description}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </Slider>
                                    :
                                    <div className="col-md-12 text-center mt-4" data-aos="fade-up">
                                        <img src={ILEmptyOrganisasi} className={'img-fluid'} width={300} /> <br />
                                        <div className='mt-4'>
                                            <p>Berita tidak ditemukan!</p>
                                        </div>
                                    </div>
                        }
                </div>
            </section>
            </> :
            <>
                <div className="d-flex justify-content-center align-items-center vh-100 bg-loading">
                    <div>
                        <img src={LOGO} className="img-fluid mb-4" width="200" />
                        <center>
                            <img src={'images/loading.gif'} className='img-fluid' width="50" />
                        </center>
                    </div>
                </div>
            </>
    );
};

export default Home;
